<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Copy Settings</v-card-title>

    <v-card-text>

        <v-select
            label="Inbox to copy from"
            :items="choices_inbox"
            v-model="from_inbox_id"
        />

        <v-select
            label="Inbox(es) to copy to"
            :items="choices_inbox"
            v-model="to_inbox_ids"
            multiple
            chips
        />

        <v-checkbox
            label="Notification Plan"
            v-model="copy_notification_plan"
            style="margin-bottom: -25px"
        />

        <v-checkbox
            label="Active Hours"
            v-model="copy_active_hours"
            style="margin-bottom: -25px"
        />

        <v-checkbox
            label="Auto Responses"
            v-model="copy_auto_responses"
        />

         <p>
            <strong>Warning</strong> copying settings will overwrite the settings in the destination inboxes.  This can not be undone.
        </p>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!is_valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>

</v-dialog>
</template>

<script>


export default {

    props: {
        choices_inbox: {
            type: Array,
            default: function() { return []; }
        },
    },

    data() {
        return {
            dialog: false,

            from_inbox_id: null,
            to_inbox_ids: [],
            
            copy_notification_plan: false,
            copy_active_hours: false,
            copy_auto_responses: false,

        }
    },

    methods: {

        showDialog(cur_inbox_id)
        {
            this.from_inbox_id = cur_inbox_id;
            this.to_inbox_ids = [];

            this.copy_notification_plan = false;
            this.copy_active_hours = false;
            this.copy_auto_responses = false;

            this.dialog = true;
        },

       
        onOk()
        {
           this.dialog = false;

            let params = {
                'from_inbox_id' : this.from_inbox_id,
                'to_inbox_ids': this.to_inbox_ids,
                'copy_notification_plan' : this.copy_notification_plan,
                'copy_active_hours' : this.copy_active_hours,
                'copy_auto_responses' : this.copy_auto_responses,
            };

           this.$emit('ok',params);
        }
    },

    computed: {
        is_valid() {
            if ( this.from_inbox_id == null ) return false;
            if ( this.to_inbox_ids.length == 0 ) return false;
            if ( this.copy_notification_plan == false && this.copy_active_hours == false && this.copy_auto_responses == false ) return false;

            return true;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>